import api from './api';

export interface Transporte {
  id?: number;
  nombre?: string;
  codigo?: string | number;
  nroExpreso?: number | string;
  nombreExpreso?: string;
  observaciones?: string | null;
  direccion?: string | null;
  telefono1?: string | null;
  telefono2?: string | null;
  fax?: string | null;
  codigoCiudad?: number | null;
  nroCuenta?: number;
  cuit?: string | null;
  lunes?: number | null;
  martes?: number | null;
  miercoles?: number | null;
  jueves?: number | null;
  viernes?: number | null;
  sabado?: number | null;
  zonas?: string | null;
  costo?: number | null;
  formaEntrega?: string | null;
  sincronizar?: number | null;
}

export interface TransporteSearchParams {
  searchTerm?: string;
  pageNumber?: number;
  pageSize?: number;
}

export interface TransportePagedResult {
  items: Transporte[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

const transporteService = {
  getTransportes: async (params?: TransporteSearchParams): Promise<Transporte[]> => {
    const resp = await api.get('/api/Transportes', params ? { params } : {});
    const data = resp.data;
    if (Array.isArray(data)) return data as Transporte[];
    if (data && typeof data === 'object' && 'items' in data) {
      return data.items as Transporte[];
    }
    return [];
  },

  getTransportesPaged: async (params: TransporteSearchParams): Promise<TransportePagedResult> => {
    const resp = await api.get('/api/Transportes', { params });
    const data = resp.data;
    
    if (Array.isArray(data)) {
      return {
        items: data,
        totalCount: data.length,
        pageNumber: params.pageNumber || 1,
        pageSize: params.pageSize || 10,
        totalPages: Math.ceil(data.length / (params.pageSize || 10))
      };
    }
    
    if (data && typeof data === 'object' && 'items' in data) {
      return data as TransportePagedResult;
    }
    
    return {
      items: [],
      totalCount: 0,
      pageNumber: params.pageNumber || 1,
      pageSize: params.pageSize || 10,
      totalPages: 0
    };
  },
  
  getTransporte: async (nroExpreso: number | string): Promise<Transporte> => {
    const resp = await api.get(`/api/Transportes/${nroExpreso}`);
    return resp.data as Transporte;
  },

  createTransporte: async (transporte: Transporte): Promise<Transporte> => {
    const response = await api.post<Transporte>('/api/Transportes', transporte);
    return response.data;
  },

  updateTransporte: async (nroExpreso: number | string, transporte: Transporte): Promise<void> => {
    await api.put(`/api/Transportes/${nroExpreso}`, transporte);
  },

  deleteTransporte: async (nroExpreso: number | string): Promise<void> => {
    await api.delete(`/api/Transportes/${nroExpreso}`);
  }
};

export default transporteService;


